import { Component, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

import { MatchingAutoMatchComponent } from './steps/auto-match/matching-auto-match.component';
import { MatchingRecordsComponent } from './steps/records-list/matching-records.component';

import { MatchingService } from '../../../../service/proxy';
import { ToastService } from '../../../shared/toast/toast.service';
import { ErrorService } from '../../../shared/services/error-service';

import { WizardStep } from '../../../shared/controls/wizard-control/wizard-step.interface';
import { WizardStepComponent } from '../../../shared/controls/wizard-control/wizard-step.component';
import { WizardControlComponent } from '../../../shared/controls/wizard-control/wizard-control.component';

@Component({
    selector: 'matching-wizard',
    standalone: true,
    templateUrl: './matching-wizard.component.html',
    styleUrl: './matching-wizard.component.scss',

    imports: [
        CommonModule,
        FormsModule,

        WizardControlComponent,
        WizardStepComponent,

        MatchingAutoMatchComponent,
        MatchingRecordsComponent
    ],

    providers: [
        MatchingService
    ]
})
export class MatchingWizardComponent implements OnInit, AfterViewInit {
    @ViewChild('autoMatchComponent')
    autoMatchComponent!: WizardStep;

    @ViewChild('autoMatchResultsComponent')
    autoMatchResultsComponent!: WizardStep;

    @ViewChild('recordsComponent')
    recordsComponent!: WizardStep;

    public batchId: number = 0;
    public activeTabIndex: number = 0;
    public viewInitialized: boolean = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private matchingService: MatchingService,
        private errorService: ErrorService,
        private toastService: ToastService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            this.batchId = +params['id'];
        });

        this.route.queryParams.subscribe(params => {
            const tab = params['tab'];
            if (tab === 'auto-match') {
                this.activeTabIndex = 0;
            } else if (tab === 'records') {
                this.activeTabIndex = 1;
            } else if (tab === 'summary') {
                this.activeTabIndex = 2;
            } else if (!isNaN(+tab)) {
                this.activeTabIndex = +tab;
            }
        });

    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.viewInitialized = true;
            this.cdr.detectChanges();
        });
    }

    isAutoMatchValid(): boolean {
        if (!this.viewInitialized) return true;
        return this.autoMatchComponent?.isValid() || false;
    }

    isAutoMatchResultsValid(): boolean {
        if (!this.viewInitialized) return true;
        return this.autoMatchResultsComponent?.isValid() || false;
    }

    isRecordsValid(): boolean {
        if (!this.viewInitialized) return true;
        return this.recordsComponent?.isValid() || false;
    }

    finished(): void {
        this.matchingService.completeMatchingBatch(this.batchId)
            .subscribe({
                next: () => {
                    this.router.navigate([`/matching`]);
                },
                error: (error: any) => {
                    this.errorService.handleError(error);
                },
                complete: () => {
                    this.toastService.show("Matching Batching completed successfully.", 'success');
                }
            }
        );
    }

    onCancel(): void {
        this.router.navigate([`/matching`]);
    }
}